<!-- generic-drawer.component.html -->
<div [ngClass]="customContainerClass" class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <mat-drawer-container (backdropClick)="onBackdropClicked()" [hasBackdrop]="hasBackdrop"
    class="drawer-container static z-[4]" autosize>
    <mat-drawer
      #drawer
      [mode]="mode"
      [position]="position"
      [ngClass]="customClasses"
      [disableClose]="disableClose"
      class="w-full sm:w-100 dark:bg-gray-900"
    >
      <ng-container [ngTemplateOutlet]="wrapper">
        <router-outlet></router-outlet>
      </ng-container>
    </mat-drawer>
    <!-- Main content here -->
    <mat-drawer-content class="bg-white h-screen">
      <ng-content select=[page]></ng-content>
    </mat-drawer-content>
  </mat-drawer-container>
</div>


<ng-template #wrapper>
  <div class="flex flex-auto h-full">
    <form class="flex flex-col flex-auto h-full px-6 pt-8 sm:px-8 sm:pt-8 pb-0 w-[inherit]">
      <ng-container *ngTemplateOutlet="headersButtons"></ng-container>
      <mat-divider role="separator" class="mat-divider mt-6 mb-8 mat-divider-horizontal"></mat-divider>
      <div class="content overflow-y-auto flex-100 pr-1 -mr-2">
        <ng-content select=[drawerContent]></ng-content>
      </div>
      <ng-container *ngIf="renderActionMenuAt === 'bottom'" >
        <ng-container *ngTemplateOutlet="footerButtons"></ng-container>
      </ng-container>
    </form>
  </div>
</ng-template>


<ng-template #headersButtons>
  <div class="flex items-center justify-between -mt-3" [class.-ml-4]="renderActionMenuAt !== 'bottom'">
    <button *ngIf="renderActionMenuAt === 'top'" (click)="handleSave()" type="button" mat-button class="pr-4 pl-3.5">
      <div class="flex items-center justify-center">
        <span *ngIf="title">{{title}}</span>
        <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
        <span class="ml-2 font-semibold">Save</span>
      </div>
    </button>
    <div class="flex items-center w-full">
      <span *ngIf="title" class="font-semibold text-2xl">{{title}}</span>

      <ng-container *ngIf="edittingEnabled">
        <button (click)="handleEdit()" type="button" mat-flat-button class="ml-auto next-button pr-4 pl-3.5">
          Edit
        </button>
        <a (click)="handleClose()" mat-icon-button class="ml-4">
          <mat-icon aria-label="Close" svgIcon="heroicons_outline:x"></mat-icon>
        </a>
      </ng-container>

      <ng-container *ngIf="!edittingEnabled">
        <a (click)="handleClose()" mat-icon-button [class.ml-auto]="renderActionMenuAt === 'bottom'">
          <mat-icon aria-label="Close" svgIcon="heroicons_outline:x"></mat-icon>
        </a>
      </ng-container>
    </div>
  </div>
</ng-template>


<ng-template #footerButtons>
  <div class="sticky bottom-0 border-t bg-gray-50 dark:bg-transparent flex items-center justify-end -ml-8 -mr-8 py-4 px-6 sm:px-8 drawer-footer">
    <a type="button" class="cursor-pointer" (click)="handleClose()">Cancel</a>
    <button *ngIf="!shouldHideSaveButton" [disabled]="disableSaveBtn" (click)="handleSave()" type="button" mat-flat-button color="primary"
      class="next-button pr-4 pl-3.5 ml-6">
      Save
    </button>
  </div>
</ng-template>
